<template>
  <div id="auth-container" v-if="surveyDetails && surveyDesign">
    <b-container>
      <b-row>
        <b-col lg="7" md="9" class="text-center mx-auto">
          <img
            :src="
              surveyDesign.logo
                ? surveyDesign.logo
                : require('@/assets/images/rush-logo.png')
            "
            alt="Survey Logo"
            class="img-fluid"
          />
        </b-col>
        <b-col lg="7" md="9" class="text-center mx-auto">
          <h2 id="survey-title">{{ surveyDetails.title }}</h2>
        </b-col>
      </b-row>
      <router-view />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Auth",
  computed: {
    ...mapGetters("survey", ["surveyDetails", "surveyDesign"]),
  },
};
</script>
